import { useState, useEffect } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import useAuth from "./useAuth";

export default function useSortedSites() {
  const serverHost = useSelector((state) => state.serverHost);
  const { auth } = useAuth();
  const [sortedSites, setSortedSites] = useState(auth?.sites_list || []);

  useEffect(() => {
    // Only fetch if serverHost and sites_list are available.
    if (serverHost && auth.sites_list && auth.sites_list.length > 0) {
      const fetchSites = async () => {
        try {
          const response = await axios.get(`${serverHost}/site/all`, {
            withCredentials: true,
          });
          // Assume response.data is an array of site objects like:
          // [{ site_name: "develop", active: true }, { site_name: "demo", active: false }, ...]
          const sitesData = response.data;
          // Create a map of site name => active status.
          const sitesMap = {};
          sitesData.forEach((site) => {
            sitesMap[site.site_name] = site.active;
          });
          // Sort auth.sites_list: active sites come first.
          const sorted = [...auth.sites_list].sort((a, b) => {
            const aActive = sitesMap[a] || false;
            const bActive = sitesMap[b] || false;
            if (aActive && !bActive) return -1;
            if (!aActive && bActive) return 1;
            return 0;
          });
          setSortedSites(sorted);
        } catch (error) {
          console.error("Error fetching sites:", error);
        }
      };

      fetchSites();
    }
  }, [serverHost, auth.sites_list]);

  return sortedSites;
}
